// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"33876dc8","793":"d38faa60"}[chunkId] + ".chunk.js";
};